var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1736240381713,
    className: "icon",
    viewBox: "0 0 1072 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 27872,
    width: 33.5,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448.61 934.766c109.616-154.43 184.563-343.138 228.937-640.83 2.096-13.701 0 46.763 0 60.563 0 188.952-48.08 333.044-80.75 421.644a21.358 21.358 0 0 0 19.505 28.77c69.924 2.73 224.158-14.19 238.007-237.568 12.239-197.779-89.235-441.295-140.19-557.056-8.973-20.383-14.97-0.927-20.627 21.309-20.724 80.75-153.21 160.573-224.5 262.339C321.341 504.686 373.906 656.09 486.4 764.002a23.406 23.406 0 0 1 3.56 29.55c-19.164 30.524-31.793 84.357-76.8 109.616-73.24 41.253 0.341 81.042 35.498 31.646z m-106.448-371.81c-31.792-80.116-56.271-174.421-67.681-293.546-0.975-10.192-15.945-10.533-17.213-0.44-17.7 149.358 26.624 239.763 47.25 306.177a15.75 15.75 0 0 1-15.457 20.382c-51.542-0.683-164.328-19.017-165.888-183.832C121.807 265.752 205.775 90.55 247.71 7.46c7.412-14.629 11.07-0.098 14.385 16.432 12.142 60.221 106.447 124.002 154.966 201.582 7.021 11.215 13.312 22.138 18.92 32.817-5.462 6.826-10.728 13.702-15.605 20.724-78.116 111.518-96.256 205.287-78.214 283.94z",
    fill: "#46766a",
    "p-id": 27873
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/亲本质量.ece67652ebcf25a95f66c0265b3c88fc.svg";
export { ForwardRef as ReactComponent };